import PropTypes from 'prop-types';
import { MenuItem, Typography, Button, Box, Divider, CircularProgress, Tooltip } from '@mui/material';
import Iconify from '../../../../../reusable-components/iconify';
import Image from '../../../../../reusable-components/image';
import { getPunchoutData } from '../../../../../api/punchout';
import { enqueueSnackbar } from '../../../../../reusable-components/snackbar';

VendorOrderLink.propTypes = {
  link: PropTypes.object,
  categoryId: PropTypes.number,
  facilityId: PropTypes.number,
  onSuccess: PropTypes.func, 
  loadingVendorPunchout: PropTypes.number,
  setLoadingVendorPunchout: PropTypes.func
}

export function VendorOrderLink({ link, categoryId, facilityId, onSuccess, loadingVendorPunchout, setLoadingVendorPunchout }) {
  const handleGetVendorLink = (purchasingVendorId) => {
    setLoadingVendorPunchout(purchasingVendorId);
    getPunchoutData(categoryId, purchasingVendorId, facilityId)
      .then(res => {
        if (res.data.errorMessage) enqueueSnackbar(res.data.errorMessage, { variant: 'error' });
        else onSuccess(res.data, link.vendorName)
      })
      .catch(() => enqueueSnackbar("Something went wrong", { variant: 'error' }))
      .finally(() => setLoadingVendorPunchout(null));
  };

  return <Tooltip title={!link.hasAccount ? "No account with vendor" : link.locked ? "User does not have permission for this category" :  ""} arrow placement="right">
    <span>
      <MenuItem disableRipple disabled={loadingVendorPunchout !== null || !link.hasAccount || link.locked}>
        <Button disabled={loadingVendorPunchout !== null} fullWidth onClick={() => handleGetVendorLink(link.purchasingVendorId)}>
          <Box display="flex" width="100%" justifyContent="space-between" alignItems="center">
            {loadingVendorPunchout !== link.purchasingVendorId ? <Image alt="vendor logo" src={link.imageUrl} style={{ width: '100px', height: 30, objectFit: 'contain' }} />
              : <Box display="flex" justifyContent="center" height={31} width="100px"><CircularProgress size={32} /></Box>}
            <span style={{ marginRight: 8 }}>
              <Typography variant="subtitle1" sx={{ ml: 1, color: "black !important" }}>
                {link.vendorName}
              </Typography>
            </span>
            <Iconify color="secondary" icon="ion:open-outline" width={16} height={16} />
          </Box>
        </Button>
      </MenuItem>
    </span>
  </Tooltip>;
};

VendorOrderLinkList.propTypes = {
  links: PropTypes.array,
  categoryId: PropTypes.number,
  facilityId: PropTypes.number,
  loadingVendorPunchout: PropTypes.number,
  setLoadingVendorPunchout: PropTypes.func,
  onSuccess: PropTypes.func,
};

export function VendorOrderLinkList({ links, categoryId, facilityId, onSuccess, loadingVendorPunchout, setLoadingVendorPunchout })
{
  return links?.map((link, index) => <Box key={index}>
    {index !== 0 && <Divider />}
    <VendorOrderLink link={link} categoryId={categoryId} facilityId={facilityId} onSuccess={onSuccess}
      loadingVendorPunchout={loadingVendorPunchout} setLoadingVendorPunchout={setLoadingVendorPunchout} />
  </Box>);
};